import React from 'react';
import { Button } from '@mui/material';
import { useGuardedNavigation } from '../../../permissions/useGuardedNavigation';

export default function SubscriptionListPageActions() {
  const { navigateCreate } = useGuardedNavigation('subscriptions');

  return (
    <Button variant="contained" color="primary" onClick={navigateCreate}>
      + Create New Subscription
    </Button>
  );
}
